'use client';
import React from 'react';
import { Grid, GridColumn } from '@kohler-dsm-library/kohler-core';
import styles from './productFeatureCarousel.module.css';
import Header from './components/Header';
import ImageCarousel from './components/ImageCarousel';
import ProductInfo from './components/ProductInfo';

export default function ProductFeatureCarousel({ data }) {
  const {
    eyebrow,
    title,
    description,
    ctaItems = [],
    imageItems = [],
    swatchImages = [],
    categories = [],
    productDetails,
    productTitle,
    colorHeadline,
    colorFinish,
    additionalText,
    accordionItems = [],
  } = data;

  return (
    <Grid className={`white-mod ${styles.pfcWrapper}`}>
      <GridColumn span={12} className={styles.headerGrid}>
        {/* HEADER SECTION */}
        <Header eyebrow={eyebrow} title={title} description={description} ctaItems={ctaItems} />
      </GridColumn>
      <GridColumn span={12} className={styles.carouselGrid}>
        {/* IMAGE CAROUSEL */}
        <ImageCarousel images={imageItems} />
      </GridColumn>
      <GridColumn span={12} className={styles.productInfoGrid}>
        {/* PRODUCT INFO (LEFT FEATURES + RIGHT OPTIONS) */}
        <ProductInfo
          productTitle={productTitle}
          productDetails={productDetails}
          swatchImages={swatchImages}
          categories={categories}
          colorHeadline={colorHeadline}
          colorFinish={colorFinish}
          additionalText={additionalText}
          accordionItems={accordionItems}
        />
      </GridColumn>
    </Grid>
  );
}
